import { useState } from 'react';

import { IRentalTile } from '@/utility/mapSearchResultToTile';

import { QuickPreviewModal } from './QuickPreviewModal';

type TTriggerComponentProps = {
  toggleQuickPreview: () => void;
};

type TQuickPreviewModalWrapperProps = {
  rentalTile: IRentalTile;
  onClickViewListing?: () => void;
  onClose?: () => void;
  TriggerComponent: (props: TTriggerComponentProps) => React.ReactNode;
};

export const QuickPreviewModalWrapper = ({
  rentalTile,
  onClickViewListing,
  onClose,
  TriggerComponent,
}: TQuickPreviewModalWrapperProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleQuickPreview = () => {
    setIsOpen(true);
  };

  return (
    <>
      <TriggerComponent toggleQuickPreview={toggleQuickPreview} />
      <div className="hidden" onClick={e => e.stopPropagation()}>
        <QuickPreviewModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            onClose?.();
          }}
          rentalTile={rentalTile}
          onClickViewListing={onClickViewListing}
        />
      </div>
    </>
  );
};
